import React from 'react';
import Component from '../../components/Component';
import { options } from './keys';
import query from './query';
import ReactSelect from '../../components/ReactSelect';

class DeviceDropdown extends Component {
    constructor() {
        super();
        this.query = query;
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            const existingOptionsKeys = this.state.data.map((x) => x.device);
            if (
                existingOptionsKeys.length !== 0 &&
                !existingOptionsKeys.includes(this.props.device)
            ) {
                this.props.updateSelect(existingOptionsKeys[0]);
            }
        }
    }

    render() {
        let filteredOptions = options;

        if (this.state.data?.[0] && !this.props.show_all) {
            const existingOptionsKeys = this.state.data.map((x) => x.device);
            filteredOptions = options.filter((x) => existingOptionsKeys.includes(x.value));
        }

        return (
            <div>
                <ReactSelect
                    options={filteredOptions}
                    value={options.find((x) => x.value === this.props.device)}
                    isSearchable={false}
                    placeholder="Select Device"
                    onChange={this.props.updateSelect}
                    blurInputOnSelect={true}
                    classname="mr-10"
                />
            </div>
        );
    }
}

export default DeviceDropdown;
